import { request } from "../../httpClient";

export const deleteUserRequest = async (id) => {
  const res = await request({
    path: "user/protected/user-delete",
    method: "POST",
    body: JSON.stringify({ id: id }),
  });
  return res;
};
